import React from 'react'
import { Card, CardActionArea, CardMedia, CardContent } from '@material-ui/core'

type MProps = {
  onClickVOD: () => void,
  type: 'normal' | 'infinity',
  content: {
    idkey: Number,
    bimg?: String,
    program: String,
  }
}

const VODCard = (props: MProps) => {
  const { type, content: { bimg, program }, onClickVOD } = props

  const name = type === 'normal' ? "" : 'sub-'
  const getImg = () => {
    if (bimg) {
      const replaceStr = bimg.replace('http://fas2.foncast.tv/', 'https://tvkorea.tv/')
      return replaceStr
    }

    return `${process.env.SERVER}/logos/preparePoster.jpg`
  }
  // const img = bimg ? bimg : `${process.env.SERVER}/logos/preparePoster.jpg`

  //   console.log(getImg())

  return (
    <Card className={`${name}item`} onClick={() => onClickVOD(props.content)}>
      <CardActionArea>
        <CardMedia
          className={`${name}card-image`}
          component="img"
          alt="Contemplative Reptile"
          title="Contemplative Reptile"
          image={getImg()}
        />
        <CardContent className={`${name}card-content`}>
          {program}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default VODCard
